<script setup lang="ts">
import {
  onMounted,
} from 'vue';
import {
  CdrText, CdrLink,
} from '@rei/cedar';
import { sendClickAnalytics } from '../../../utils';
import { snakeCase, camelCaseWithoutSC } from '../../../common/utils';
import { PopularTopicsSection } from '../../../api/types/PopularTopicsSection';
import { PopularTopicsExtraLinks } from '../../../common/models/constants/PopularTopicsExtraLinks';

const props = defineProps<{
  popularTopicsSection?: PopularTopicsSection;
}>();

const linkHandler = (saleName?: string, linkName?: string) => {
  const tag = saleName
    ? `rei:Help_Center_${snakeCase(saleName)}_Help_${camelCaseWithoutSC(linkName)}`
    : `rei:Help_Center_Homepage_Popular_${linkName}`;
  analyticsHandler(tag);
};

const analyticsHandler = (source: string) => {
  const clickData = {
    pageName: '',
    linkName: source || 'rei:Help_Center',
  };
  sendClickAnalytics(clickData);
};

onMounted(() => {
  props.popularTopicsSection.cardModelList.forEach((card: Record<string, any>) => {
    const { urlModelList, cardHeading } = card;
    const extra = PopularTopicsExtraLinks[(cardHeading ?? '')];
    // only append when mapping exists
    if (extra) {
      urlModelList.push(extra);
    }
  });
});
</script>

<template>
  <CdrText
    tag="h2"
    tabindex="0"
    class="help-center__heading-links"
  >
    {{ popularTopicsSection?.sectionHeading }}
  </CdrText>
  <article
    class="help-center__card-links-container"
  >
    <div
      v-for="popularTopicsCard in popularTopicsSection?.cardModelList"
      :key="popularTopicsCard.key"
      class="help-center__card-links-card"
    >
      <cdr-text
        tag="h3"
        tabindex="0"
        class="help-center__card-title"
      >
        {{ popularTopicsCard.cardHeading }}
      </cdr-text>
      <ul class="help-center__card-links-list">
        <li
          v-for="popularTopicsLink in popularTopicsCard.urlModelList"
          :key="popularTopicsLink.key"
          class="help-center__card-links-text"
        >
          <CdrLink
            :href="popularTopicsLink.url"
            :aria-label="popularTopicsLink.ariaLabel"
            @click="linkHandler(popularTopicsSection?.key, popularTopicsLink.urlText)"
          >
            {{ popularTopicsLink.urlText }}
          </CdrLink>
        </li>
      </ul>
    </div>
  </article>
</template>

<style scoped></style>
